import { doc, getDoc } from 'firebase/firestore';
import { firestore } from '../services/firebase';

// Configuration for petition type ordering (fallback)
export const PETITION_TYPE_ORDER_FALLBACK = [
  'no_funds',
  'incorrect_applicationByCargo',
  'incorrect_ApplicationByEmail',
  'missing_document',
  'notYet_Due',
  'same_spot_damage',
  'mediation_Agreement',
  'driver_WithoutFault',
  'severe_damage',
  'bad_faith',
  'final_Judgment',
  'legalCase_Ongoing',
  'without_policy',
  'outOf_Hours',
  'foreign_LicensePlate',
];

// Cache for the petition type order to avoid repeated Firestore calls
let cachedPetitionTypeOrder = null;
let cacheTimestamp = null;
const CACHE_DURATION = 5 * 60 * 1000; // 5 minutes

// Function to fetch petition type order from config collection
export const getPetitionTypeOrder = async () => {
  // Return cached value if still valid
  if (
    cachedPetitionTypeOrder &&
    cacheTimestamp &&
    Date.now() - cacheTimestamp < CACHE_DURATION
  ) {
    return cachedPetitionTypeOrder;
  }

  try {
    const configDoc = await getDoc(doc(firestore, 'config', 'orders'));
    if (configDoc.exists() && configDoc.data().petition_type) {
      const order = configDoc.data().petition_type.split(',');

      // Validate that it's an array
      if (Array.isArray(order) && order.length > 0) {
        cachedPetitionTypeOrder = order;
        cacheTimestamp = Date.now();
        console.log(
          'Loaded petition type order from config collection:',
          order,
        );
        return order;
      }
    }

    console.log('Config collection not found or invalid, using fallback order');
  } catch (error) {
    console.warn('Error fetching petition type order from config:', error);
  }

  // Fallback to constant order
  cachedPetitionTypeOrder = PETITION_TYPE_ORDER_FALLBACK;
  cacheTimestamp = Date.now();
  return PETITION_TYPE_ORDER_FALLBACK;
};

// Function to sort templates based on petition type order
export const sortTemplatesByPetitionTypeOrder = async (templates) => {
  if (!Array.isArray(templates)) return templates;

  const petitionTypeOrder = await getPetitionTypeOrder();

  return [...templates].sort((a, b) => {
    const aIndex = petitionTypeOrder.indexOf(a.id);
    const bIndex = petitionTypeOrder.indexOf(b.id);

    // If both templates are in the order list, sort by their position
    if (aIndex !== -1 && bIndex !== -1) {
      return aIndex - bIndex;
    }

    // If only template 'a' is in the order list, it comes first
    if (aIndex !== -1 && bIndex === -1) {
      return -1;
    }

    // If only template 'b' is in the order list, it comes first
    if (aIndex === -1 && bIndex !== -1) {
      return 1;
    }

    // If neither template is in the order list, maintain original order
    return 0;
  });
};

// Export the fallback order for backward compatibility
export const PETITION_TYPE_ORDER = PETITION_TYPE_ORDER_FALLBACK;
